export default "__VITE_ASSET__BbdULvZ9__"